
let _weibo = {

    //加载基础代码
    load: function(){
        let js = '(function(root) {\n' +
            '        var script = document.createElement(\'script\');\n' +
            '        script.type = \'text/javascript\';\n' +
            '        script.crossOrigin = \'anonymous\';\n' +
            '        script.src = \'//cheka.biz.weibo.com/snippet\'; \n' +
            '        script.onerror = function() {\n' +
            '            const img = document.createElement(\'img\')\n' +
            '            img.src = \'//cheka.biz.weibo.com/api/v1/events/collect?t=load.error&dl=\' +\n' +
            '                encodeURIComponent(location.href) + \'&rf=\' + encodeURIComponent(document.referrer) +\n' +
            '                \'&st=\' + performance.now() + \'&ts=\' + Date.now();\n' +
            '        }\n' +
            '        var s = document.getElementsByTagName(\'script\')[0];\n' +
            '        s.parentNode.insertBefore(script, s);\n' +
            '    })(window);';

        let _head = document.getElementsByTagName("head")[0];
        let script = document.createElement("script");
        script.append(js);
        _head.appendChild(script);
    },

    //加载事件代码 - 事件资产ID
    submit: function (assets_id) {
        try {
            var conversionEvent = {
                eventtype: 'form', //
                eventvalue: '', //
                assetsid: assets_id + ''
            }
            if(window.wbadmt && window.wbadmt.send) {
                window.wbadmt.send(conversionEvent)
            } else {
                window.addEventListener('cheka:ready', function () { window.wbadmt.send(conversionEvent) }, false)
            }

        } catch (e) {
            console.log(e)
        }
    },
};

export default _weibo
